export default __webpack_public_path__ + "static/media/chatbot-user-icon.27fe6761.png";